import { snapshot } from 'valtio'
import { editableRoadSegment } from '../editableRoadSegment'

export function getEditableRoadSegment(immutable = true) {
  return immutable ? snapshot(editableRoadSegment.roadSegment) : editableRoadSegment.roadSegment
}
